import React, { ReactNode } from 'react';
import { Breadcrumb, Flex, Layout, Menu, theme } from 'antd';
import AppFooter from './AppFooter';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import {
    LoginOutlined, LogoutOutlined, UserOutlined, BarsOutlined,
    InteractionOutlined, CodeOutlined, CloudServerOutlined, QuestionCircleOutlined,
} from '@ant-design/icons';
import ServerSelector from '../components/ServerSelector';
import { useAuth } from '../context/AuthContext';

const { Header, Content } = Layout;

interface MainWrapperProps {
    children: ReactNode;
}

const MainWrapper: React.FC<MainWrapperProps> = ({ children }) => {
    const { token: { colorBgContainer, borderRadiusLG } } = theme.useToken();
    const location = useLocation();
    const navigate = useNavigate();
    const { isAuthenticated, logout } = useAuth();

    const breadcrumb_items = location.pathname.slice(1).split('/').map((route) => ({
        title: route.replace(/_/g, ' '),
    }));

    const signOut = () => {
        logout();
    };

    const navItems = [
        { key: 'users', label: 'Users', icon: <UserOutlined />, path: '/dashboard/users' },
        { key: 'coins', label: 'Coin List', icon: <BarsOutlined />, path: '/dashboard/coins' },
        { key: 'active', label: 'Active Coin', icon: <InteractionOutlined />, path: '/dashboard/active_coin' },
        { key: 'logs', label: 'Bot Log', icon: <CodeOutlined />, path: '/dashboard/bot_log' },
        { key: 'support', label: 'Support', icon: <QuestionCircleOutlined />, path: '/dashboard/answer_question' },
        { key: 'servers', label: 'Bot Servers', icon: <CloudServerOutlined />, path: '/dashboard/bot_servers' },
    ];

    const menuItems = [
        ...navItems.map((item, i) => ({
            key: String(i + 1),
            label: item.label,
            icon: item.icon,
            onClick: () => navigate(item.path),
        })),
        {
            key: 'logout',
            label: isAuthenticated ? 'Logout' : 'Login',
            icon: isAuthenticated ? <LogoutOutlined /> : <LoginOutlined />,
            onClick: () => isAuthenticated ? signOut() : navigate('/login'),
        },
    ];

    const isBotLogPage = location.pathname.includes('bot_log');

    const showServerSelector = isAuthenticated
        && !location.pathname.includes('bot_servers')
        && !location.pathname.includes('answer_question')
        && !isBotLogPage;

    return (
        <>
            <Layout style={{ minHeight: '100vh' }}>
                <Header style={{ display: 'flex', alignItems: 'center', padding: '0 24px', background: '#001529' }}>
                    <Flex style={{ marginRight: 24 }} align="center">
                        <NavLink to="/" style={{ textDecoration: 'none' }}>
                            <span style={{ fontSize: 22, color: 'white', fontWeight: 600 }}>Solarba Monitor</span>
                        </NavLink>
                    </Flex>
                    {showServerSelector && <ServerSelector />}
                    <Menu
                        theme="dark"
                        mode="horizontal"
                        selectable={false}
                        items={menuItems}
                        style={{ flex: 1, minWidth: 0, justifyContent: 'flex-end', background: 'transparent' }}
                    />
                </Header>
                <Content style={{ padding: isBotLogPage ? 0 : '0 24px' }}>
                    {!isBotLogPage && <Breadcrumb style={{ margin: '16px 0' }} items={breadcrumb_items} />}
                    <div
                        style={
                            isBotLogPage
                                ? { minHeight: 'calc(100vh - 64px)', background: '#010409' }
                                : {
                                    background: colorBgContainer,
                                    minHeight: 'calc(100vh - 170px)',
                                    padding: 24,
                                    borderRadius: borderRadiusLG,
                                }
                        }
                    >
                        {children}
                    </div>
                </Content>
                {!isBotLogPage && <AppFooter children={undefined} />}
            </Layout>
            <ToastContainer />
        </>
    );
};

export default MainWrapper;
